import { Outlet } from "react-router-dom";

const LibraryMainPage = () => {
    return <Outlet />;
}

export default LibraryMainPage;